import { renderToStaticMarkup } from "react-dom/server";
import { GardenPlant } from "@/components/client/Garden";

const W = 1400, H = 1000;

function plantImage(stage) {
  const svg = renderToStaticMarkup(<GardenPlant stage={stage} progress={1} animate={false} century={true} />).replace("<svg", '<svg xmlns="http://www.w3.org/2000/svg"');
  return new Promise((res) => { const img = new Image(); img.onload = () => res(img); img.src = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`; });
}

function fmt(d) { return new Date(d + "T12:00:00").toLocaleDateString(undefined, { year: "numeric", month: "long", day: "numeric" }); }

/** Printable keepsake: cream stock, the rose, the number or habit, the date. Name only if the member asks for it. */
export async function drawCertificate(canvas, m, stage, name) {
  const ctx = canvas.getContext("2d");
  canvas.width = W; canvas.height = H;
  ctx.fillStyle = "#f7f1e6"; ctx.fillRect(0, 0, W, H);
  ctx.fillStyle = "#e9e0cf"; for (let i = 0; i < 260; i++) ctx.fillRect((i * 131) % W, (i * 197) % H, 2, 2);
  ctx.strokeStyle = "#9a3412"; ctx.lineWidth = 4; ctx.strokeRect(40, 40, W - 80, H - 80);
  ctx.strokeStyle = "#d6c8b2"; ctx.lineWidth = 1.5; ctx.strokeRect(56, 56, W - 112, H - 112);
  ctx.textAlign = "center";
  ctx.fillStyle = "#9a3412"; ctx.font = "bold 26px ui-sans-serif, system-ui"; ctx.letterSpacing = "8px";
  ctx.fillText(m.kind === "century" ? "THE CENTURY CLUB" : "ROOTED", W / 2, 150); ctx.letterSpacing = "0px";
  ctx.fillStyle = "#1c1917"; ctx.font = "800 150px Georgia, ui-serif, serif";
  if (m.kind === "century") ctx.fillText("100", W / 2, 330);
  else { ctx.font = "800 72px Georgia, ui-serif, serif"; ctx.fillText(m.habit_title || "A habit", W / 2, 310); }
  ctx.fillStyle = "#57534e"; ctx.font = "500 30px ui-sans-serif, system-ui";
  ctx.fillText(m.kind === "century" ? "check-ins — showing up, again and again" : "climbed its whole ladder and held at the top two weeks running", W / 2, 390);
  if (name) { ctx.fillStyle = "#1c1917"; ctx.font = "italic 600 44px Georgia, ui-serif, serif"; ctx.fillText(name, W / 2, 470); }
  const img = await plantImage(stage);
  ctx.drawImage(img, W / 2 - 150, 480, 300, 400);
  ctx.fillStyle = "#57534e"; ctx.font = "500 28px ui-sans-serif, system-ui";
  ctx.fillText(fmt(m.earned_at), W / 2, 930);
  ctx.fillStyle = "#9a3412"; ctx.font = "bold 20px ui-sans-serif, system-ui"; ctx.letterSpacing = "4px";
  ctx.fillText("ROOT & ROSE  ·  ROSE CITY THERAPEUTICS", W / 2, 965); ctx.letterSpacing = "0px";
  ctx.textAlign = "left";
}

export async function downloadCertificate(m, stage, name) {
  const c = document.createElement("canvas");
  await drawCertificate(c, m, stage, name);
  const blob = await new Promise((res) => c.toBlob(res, "image/png"));
  const a = document.createElement("a"); a.href = URL.createObjectURL(blob); a.download = `${m.kind === "century" ? "century-club" : "rooted"}-certificate.png`; a.click();
  setTimeout(() => URL.revokeObjectURL(a.href), 2000);
}
